import { ActionButton, Flex } from '@adobe/react-spectrum';
import React, { FC, useState } from 'react';
import Move from '@spectrum-icons/workflow/SelectionMove';
import { CanvasCameraSliders } from './canvasCameraSliders';

export const CanvasCameraPosition: FC = () => {
    const [show, setShow] = useState(false);

    if (!show) {
        return (
            <Flex
                flex
                alignItems="center"
                direction="column"
                gap="size-100"
                position="absolute"
                zIndex={2}
                top="10px"
                left="10px"
            >
                <ActionButton onPress={() => setShow(!show)}>
                    <Move />
                </ActionButton>
            </Flex>
        );
    }

    return <CanvasCameraSliders setShow={setShow} />;
};
